import { render, staticRenderFns } from "./PartialRejectionNote.vue?vue&type=template&id=f1cd706e&scoped=true"
import script from "./PartialRejectionNote.vue?vue&type=script&lang=ts"
export * from "./PartialRejectionNote.vue?vue&type=script&lang=ts"
import style0 from "./PartialRejectionNote.vue?vue&type=style&index=0&id=f1cd706e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cd706e",
  null
  
)

export default component.exports